// External libraries
import { css } from '@emotion/core';

const sectionStyles = css`
  margin-bottom: 16px;

  > div:not(:last-of-type) {
    margin-bottom: 12px;
  }

  @media (min-width: 365px) {
    margin-bottom: 24px;
  }
`;

export { sectionStyles };
